import { kiraB50Thumbnail } from 'assets/images';

export const renderColumns = (t) => [
  {
    width: 80,
    dataIndex: 'image',
    render: () => {
      return (
        <img
          className="machine-image"
          width={50}
          src={kiraB50Thumbnail}
          alt="machine"
        />
      );
    }
  },
  {
    width: 120,
    dataIndex: 'serialNumber',
    render: (serialNumber) => {
      return (
        <div>
          <h5>{t('myMachinesTable.columns.serialNumber')}</h5>
          <span>{serialNumber}</span>
        </div>
      );
    }
  },
  {
    width: 100,
    dataIndex: 'alias',
    render: (alias) => {
      return (
        <div>
          <h5>{t('myMachinesTable.columns.alias')}</h5>
          <span>{alias}</span>
        </div>
      );
    }
  },
  {
    width: 80,
    dataIndex: 'facility',
    render: (facility) => {
      return (
        <div>
          <h5>{t('myMachinesTable.columns.facility')}</h5>
          <span>{facility}</span>
        </div>
      );
    }
  },
  {
    width: 180,
    dataIndex: 'object',
    render: (object) => {
      return (
        <div>
          <h5>{t('myMachinesTable.columns.object')}</h5>
          <span>{object}</span>
        </div>
      );
    }
  }
];
